import React, {Component} from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Dropzone from "./dropzone";
import Datepicker from "./datepicker";
import { withRouter } from "react-router-dom";
import moment from 'moment';
import { loader } from '../../../actions/utils';
import { savePreview, savePromotion, fetchReach } from "../../../actions/promotionAction";
import { evcwalletPayment } from "../../../actions/evcAction";
import { cloudinaryMediaUploader } from './../../../helpers/cloudinaryFileUploader';
import { getlanguagelist } from "../../../helpers/changelanguage";
import  WalletConnection  from "./walletconnection";
import Chip from '@material-ui/core/Chip';
import {ToastsContainer, ToastsStore, ToastsContainerPosition} from 'react-toasts';


class PromotionPreview extends Component {
    constructor(props) {
      super(props);
      this.state = {
        headerData            : {},
        display               : this.props.preview.display,
        custom_display        : this.props.preview.custom_display,
        checked               : this.props.preview.checked,
        promotionType         : this.props.preview.promotionType,
        costSetup             : this.props.preview.costSetup,
        selection_range       : this.props.preview.selection_range,
        promotion_days        : this.props.preview.promotion_days,
        is_editablecost       : this.props.preview.is_editablecost,
        base_cost             : this.props.preview.base_cost,
        min_cost              : this.props.preview.min_cost,
        max_cost              : this.props.preview.max_cost,
        currency              : this.props.preview.currency,
        start_date            : this.props.preview.start_date,
        end_date              : this.props.preview.end_date,
        perday_reach          : this.props.preview.perday_reach,
        total_reach           : this.props.preview.total_reach,
        perday_spent          : this.props.preview.perday_spent,
        slider_percentage     : this.props.preview.slider_percentage,
        promotion_description : this.props.preview.promotion_description,
        promotion_heading     : this.props.preview.promotion_heading,
        start_age             : this.props.preview.start_age,
        end_age               : this.props.preview.end_age,
        gender                : this.props.preview.gender,
        age_range             : this.props.preview.age_range,
        hobby_range           : this.props.preview.hobby_range,
        hobby_range_name      : this.props.preview.hobby_range_name,
        hobby_range_json      : this.props.preview.hobby_range_json,
        country_range         : this.props.preview.country_range,
        country_range_name    : this.props.preview.country_range_name,
        country_range_json    : this.props.preview.country_range_json,
        profession_range      : this.props.preview.profession_range,
        profession_range_name : this.props.preview.profession_range_name,
        profession_range_json : this.props.preview.profession_range_json,
        image_list            : this.props.preview.image_list,
        file_list             : this.props.preview.file_list,
        media_files           : this.props.preview.media_files,
        go_preview            : this.props.preview.go_preview,
        budget_type           : this.props.preview.budget_type,
        limitList             : this.props.preview.limitList,
        payment_mode          : this.props.preview.payment_mode,
        spinner               : this.props.preview.spinner,
        modal                 : false,
        new_promotion_id      : 0
    };
      
      this.goEdit         = this.goEdit.bind(this);
      this.savePromotion  = this.savePromotion.bind(this);
      this.changeFile     = this.changeFile.bind(this);
      this.calculateReach = this.calculateReach.bind(this);
      this.openModal      = this.openModal.bind(this);
      this.closeModal     = this.closeModal.bind(this);
      this.evcpayment     = this.evcpayment.bind(this);
    }
    componentDidMount() { 
      
    }
    UNSAFE_componentWillReceiveProps(nextProps){     
        if(nextProps.savepromotion != this.props.savepromotion){
            this.setState({
                new_promotion_id : nextProps.savepromotion.promotion_id
            },function(){
                if(this.state.budget_type == 'Free'){
                    this.props.history.push(`/promotion_list`)
                }else{
                    if(this.state.payment_mode == 'Cash'){
                        this.props.history.push(`/promotion_list`)
                    }else{
                        if(this.state.payment_mode == 'Online'){
                            window.location.href = nextProps.savepromotion.payment_url; 
                        }else{
                            this.openModal();
                        }
                    }
                   
                }
            })
            
        }

        if(nextProps.calculateReach != this.props.calculateReach){
            this.setState({
                perday_reach        : parseInt(nextProps.calculateReach.per_day_reach),
                total_reach         : parseInt(nextProps.calculateReach.total_reach),
                slider_percentage   : Math.round((parseInt(nextProps.calculateReach.per_day_reach)/parseInt(nextProps.calculateReach.total_reach))*100),
                perday_spent        : nextProps.calculateReach.perday_amount_utilize,
                spinner             : ''
                
            },function(){
                if(this.state.go_preview == 1){
                    this.props.savePreview(this.state);
                    
                    this.props.history.push(`/promotion_preview`)
                }else if(this.state.go_preview == 2) {
                    this.savePromotion();
                }
                
            })  
        }

        if(nextProps.evc != this.props.evc){
            this.closeModal();
            let languagelist = getlanguagelist();
            if(Object.keys(nextProps.evc).length == 0){
                ToastsStore.error(languagelist.evcwalletfailure);
            }else{
                ToastsStore.success(languagelist.evcwalletsuccess);
            }
            this.props.history.push(`/promotion_list`)
        }
    }
    
   
    goEdit(){
        this.props.history.push(`/promotion_edit`)
    
    }   
    
    savePromotion(){
        
        let param = {
            chk_by_recent_reg     : (this.state.checked == true) ? 'YES' : 'NO',
            start_age             : this.state.age_range[0],
            end_age               : this.state.age_range[1],
            profession            : JSON.stringify(this.state.profession_range),
            gender                : this.state.gender,
            country               : this.state.country_range,
            hobby                 : JSON.stringify(this.state.hobby_range),
            start_date            : (moment(this.state.start_date).format('YYYY-MM-DD')),//this.state.start_date,
            end_date              : (moment(this.state.end_date).format('YYYY-MM-DD')),//this.state.end_date,
            total_days            : this.state.promotion_days,
            min_budget            : this.state.min_cost,
            max_budget            : this.state.max_cost,
            total_budget          : this.state.base_cost,
            budget_type           : this.state.budget_type,
            promotion_type        : 'CUSTOM',
            promotion_name        : this.state.promotion_heading,
            promotion_description : this.state.promotion_description,
            promotion_pic         : JSON.stringify(this.state.media_files),
            payment_mode          : this.state.budget_type == 'Free' ? '' : 'Online'
        }
        this.props.savePromotion(param);
   
    }

    calculateReach(state){
        this.setState({
            spinner : 'fa-spin'
        });
        if(state.checked == true)
        {   
            let reqParam = {
                chk_by_recent_reg       : 'Yes',
                rcnt_reg_filter_type    : state.selection_range,
                total_days              : state.promotion_days,
                min_budget              : state.min_cost,
                max_budget              : state.max_cost,
                total_budget            : state.base_cost,
                budget_type             : state.promotionType.promotion_type.budget_type,
            };
            this.props.fetchReach(reqParam);
        }else{
            let hobby_list = this.state.hobby_range_json;//JSON.parse($("#hobby_range").val());
           
            let hobby_list_id = [];
            let hobby_list_name = [];
            hobby_list.map((row,index) => {
                hobby_list_id.push(row.id)
                hobby_list_name.push(row.category_name)
            })
           
            this.setState({
                hobby_range      : hobby_list_id,
                hobby_range_name : hobby_list_name,
              //  hobby_range_json : JSON.parse($("#hobby_range").val())
            })

            let country_list = this.state.country_range_json;//JSON.parse($("#country_range").val());
            let country_list_id = country_list[0].country_code;
            this.setState({
                country_range      : country_list_id,
                country_range_name : country_list[0].country_name,
               // country_range_json : JSON.parse($("#country_range").val())
            })
           
            let profession_list = this.state.profession_range_json; //JSON.parse($("#profession_range").val());
            let profession_list_id   = [];
            let profession_list_name = [];
            
            profession_list.map((row,index) => {
                profession_list_id.push(row.id);
                profession_list_name.push(row.category_name);
            })
            this.setState({
                profession_range      : profession_list_id,
                profession_range_name : profession_list_name,
                //profession_range_json : JSON.parse($("#profession_range").val())

            })
            let reqParam = {
                chk_by_recent_reg       : 'No',
                start_age               : state.age_range[0],
                end_age                 : state.age_range[1],
                profession              : JSON.stringify(profession_list_id),
                gender                  : state.gender,
                country                 : country_list_id,
                hobby                   : JSON.stringify(hobby_list_id),
                total_days              : state.promotion_days,
                min_budget              : state.min_cost,
                max_budget              : state.max_cost,
                total_budget            : state.base_cost,
                budget_type             : state.promotionType.promotion_type.budget_type,
            };
            this.props.fetchReach(reqParam);
        }
           
    }

    changeFile(){
        if(this.state.file_list.length > 0){
            let new_res = [];
            let uploadResponse = [];
            loader(true);
            uploadResponse = cloudinaryMediaUploader(this.state.file_list);
            uploadResponse.then((response)=>{
                response.map(res => {
                new_res.push({'media_type':res.data.resource_type,'media_link':`${res.data.public_id}.${res.data.format}`});
                })
                this.setState({
                media_files: new_res,
                go_preview : 2
                },function(){
                    
                    this.calculateReach(this.state);    
                   
                });
            });
        }else{
            this.setState({
                go_preview : 2
            },function(){
                    
                this.calculateReach(this.state);    
                   
                    // this.savePromotion();
            });
            //this.savePromotion();
        }
    }
    
    openModal(){
        this.setState({
            modal : true
        })
    }
    closeModal(){
        this.setState({
            modal : false
        })
    }
   
    evcpayment(phone){

        let param = {
            reference_id     : this.state.new_promotion_id,
            payment_reason   : 'PROMOTION',
            phone_no         : `252${phone}`
        }
        this.props.evcwalletPayment(param);  
    } 

    render() {
        let languagelist = getlanguagelist();
        let limit = this.props.preview.limitList || [];
        return (
            <div className="content_area">
                <div className="col-lg-12">
                    <h3 className="heading_2">{languagelist.previewpromotion}:</h3>
                </div>
                <div className="clr10"></div>

                <div className="col-xs-12 col-sm-6 col-md-3 col-lg-3 left_area">
                    <div className="left_fixt">
                          <div className="post_box known">
                            <h3>{languagelist.promotiondes}</h3>
                            <div className="description_box">
                               {this.props.preview.promotion_description}
                            </div>
                        </div>

                    </div>

                </div>
                <div className="col-xs-12 col-sm-12 col-md-6 col-lg-9 post_area">
                    <div className="row">
                    <div className="post_box known">

                        <div className="clr20"></div>

                        <div className="col-lg-12">
                            <div className="infi_fild">
                                <img className="pull-left" src="/assets/images/commend_circle.png" />
                                <div className="input_mid pull-left">
                                    <label>{languagelist.promotionhead}</label>
                                    <div className="clr10"></div>
                                    {this.props.preview.promotion_heading}
                                   
                                </div>
                                <div className="clearfix"></div>
                            </div>
                            <div className="clr10"></div>
                            <Dropzone setFileList={this.setFileList} file_list={this.props.preview.file_list}/>
                        </div>


                        <div className="clr20"></div>
                    </div>


                    {
                        (this.props.preview.checked == true) ? 
                        <div className="post_box pad_15">
                        

                            <label >{languagelist.selection}  </label>
                           {/*  <Chip label={this.props.preview.selection_range} variant="outlined" /> */}
                            <div className="clr20"></div>
                            <div className="col-lg-3" style={{display:this.state.display}} >
                                <select className="form-control" name="selection_range"  value={this.props.preview.selection_range} readOnly>
                                    {
                                        limit.map((limit,index) => {
                                            return ( <option value={limit.id} key={`limit_${index}`}>{limit.category_name}</option>
                                                    )
                                        })
                                    }
                                </select>
                            </div>
                            
                        </div>
                        : null 
                    }
                    </div>
                </div>

                <div className="col-lg-12">
                    <div className="row">

                        <div className="col-lg-3" style={(this.props.preview.checked == false) ? {display:'block'} : {display:'none'}}>
                            <div className="post_box known">
                                <div className="post_box_padd_slider">
                                    <div className="text-center">
                                        
                                        <img src="/assets/images/age_group_icon.png" />
                                        <h4>{languagelist.agegrp}</h4>
                                        <div className="clr20"></div>
                                        {this.props.preview.age_range[0]} to {this.props.preview.age_range[1]}
                                       {/*  <input type="range" min="1" max="100" value="50" onChange={this.onChange}/> */}
                                       {/* <AgeSlider start_age={this.state.start_age} end_age={this.state.end_age} onSliderChange={this.onSliderChange} onChange={this.onChange}/> */}
                                        
                                   </div>
                                   
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-3" style={(this.props.preview.checked == false) ? {display:'block'} : {display:'none'}}>
                            <div className="row">
                                <div className="post_box known">
                                <div className="post_box_padd">
                                    <div className="text-center">
                                        
                                        <img src="/assets/images/hobby_icon.png" />
                                        <h4>{languagelist.promotionprof}</h4>
                                        <div className="clr20"></div>

                                        {
                                            this.props.preview.profession_range_name.map( (profession,index) => {
                                                return (
                                                    <div key={`professionsdiv_${index}`}>
                                                    <Chip label={profession} variant="outlined" key={`professions_${index}`}/>
                                                    <div className="clr20"></div>
                                                    </div>
                                                )
                                            })
                                        }

                                    </div>

                                </div>
                            </div>
                            </div>
                        </div>
                        <div className="col-lg-3" style={(this.props.preview.checked == false) ? {display:'block'} : {display:'none'}}>
                            <div className="post_box known">
                                <div className="post_box_padd">
                                    <div className="text-center">
                                        
                                        <img src="/assets/images/gesder_icon.png" />
                                        <h4>{languagelist.gender}</h4>
                                        <div className="clr20"></div>

                                        <div className="gendar_list">
                                            <a className={(this.props.preview.gender == 'ALL') ? 'active' : ''} href={void(0)} >{languagelist.all}</a>
                                            <a className={(this.props.preview.gender == 'M') ? 'active' : ''} href={void(0)} >{languagelist.men}</a>
                                            <a className={(this.props.preview.gender == 'F') ? 'active' : ''} href={void(0)} >{languagelist.women}</a>
                                            <a className={(this.props.preview.gender == 'T') ? 'active' : ''} href={void(0)} >{languagelist.otherg}</a>
                                            
                                        </div>

                                    </div>

                                </div>
                            </div>
                        </div>

                        <div className="col-lg-3" style={(this.props.preview.checked == false) ? {display:'block'} : {display:'none'}}>
                            <div className="row">
                                <div className="post_box known">
                                <div className="post_box_padd">
                                    <div className="text-center">
                                        
                                        <img src="/assets/images/cuntry_icon.png" />
                                        <h4>{languagelist.country}</h4>
                                        <div className="clr20"></div>
                                        <Chip label={this.props.preview.country_range_name} variant="outlined" />
                                    </div>

                                </div>
                            </div>
                            </div>
                        </div>


                    </div>

                    <div className={(this.props.preview.checked == false) ? "row" : "row  div-bottom"}>
                        <div className="col-lg-3" style={(this.props.preview.checked == false) ? {display:'block'} : {display:'none'}}>
                            <div className="post_box known">
                                <div className="post_box_padd">
                                    <div className="text-center">
                                        
                                        <img src="/assets/images/hobby_icon.png" />
                                        <h4>{languagelist.hobbies}</h4>
                                        <div className="clr20"></div>
                                        {
                                            this.props.preview.hobby_range_name.map( (hobby,index) => {
                                                return (
                                                    <div key={`hobbysdiv_${index}`}>
                                                    <Chip label={hobby} variant="outlined" key={`hobbys_${index}`}/>
                                                    <div className="clr20"></div>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={(this.props.preview.checked == false) ? "col-lg-9" : "col-lg-12"}>
                            <div className="row">
                                <div className="post_box known">
                                <div className="post_box_padd">
                                    <div className="text-center">
                                       
                                        <img src="/assets/images/calendar_icon.png" />
                                        <h4>{languagelist.durabudget}</h4>
                                        <div className="clr20"></div>
                                    </div>
                                    <div className="col-lg-6" style={{paddingRight :'40px'}}>
                                        <div className="row">

                                            <div className="col-lg-5 date-show" >
                                                <span style={{color : '#4189DD'}}><i className="fa fa-calendar" aria-hidden="true"></i> {moment(this.props.preview.start_date).format('MMM Do YYYY')}</span>
                                               
                                            </div>
                                            <div className="col-lg-2">
                                                <span>{languagelist.to}</span>
                                            </div>
                                            <div className="col-lg-5 date-show">
                                                <span style={{color : '#4189DD'}}><i className="fa fa-calendar" aria-hidden="true"></i> {moment(this.props.preview.start_date).format('MMM Do YYYY')}</span>
                                             
                                            </div>
                                           {/*  <div className="col-lg-6">
                                                <span>{languagelist.fdate}</span>
                                                <Datepicker defaultDate={this.props.preview.start_date} type="startDate"/>
                                            </div>
                                            <div className="col-lg-6">
                                                <span>{languagelist.tdate}</span>
                                                <Datepicker defaultDate={this.props.preview.end_date} type="endDate"/>
                                            </div>
                                            */}
                                           {/*  <div className="col-lg-6">

                                                <a href="#" className="line_box line_box_active_2 btn-block">{this.props.preview.promotion_days} {languagelist.days}</a>
                                            </div>
                                            <div className="col-lg-6">
                                              <p className="price_sim">$</p>  
                                              <input className="line_box line_box_active btn-block price_input" type="number" name="base_cost" value={this.props.preview.base_cost} readOnly />
                                            
                                            </div> */}

                                            <div className="col-lg-12">
                                                <span className="rdays">{languagelist.budget}</span>
                                            </div>
                                            <div className="col-lg-5">
                                                 <a href="#" className="line_box line_box_active_2 btn-block"> {this.props.preview.promotion_days} {languagelist.days} </a>
                                            </div>
                                            <div className="col-lg-1 text-center">
                                                <div className="row"> <p className="price_sim">$</p></div>
                                            </div>
                                            <div className="col-lg-5">
                                             
                                              <input className="line_box line_box_active btn-block price_input" type="number" name="base_cost" value={this.props.preview.base_cost} readOnly />
                                            </div>

                                            <div className="col-lg-12">
                                                <span className="rdays"><i className="fa fa-clock" aria-hidden="true"></i> {languagelist.remaindays}</span>
                                            </div>
                                            <div className="col-lg-12">
                                                <span  className="ldays">{this.props.preview.promotion_days}  {languagelist.daysleft}</span>
                                            </div>
                                            <div className="col-lg-12">
                                                <span className="rdays"> <img src="/assets/images/price_icon.png" /> {languagelist.paymentmode}</span>
                                            </div>
                                            <div className="col-lg-12">
                                                <span  className="ldays">{(this.props.preview.budget_type == 'Free') ? languagelist.notavail : languagelist[this.props.preview.payment_mode]} </span>
                                            </div>
                                        </div>

                                    </div>
                                    <div className="col-lg-6 with_sep">
                                        <ul className="budget_list">
                                            <li>
                                                <img src="/assets/images/price_icon.png" /> {languagelist.remainbudget}
                                                <br/>
                                                <a href="#" className="addnew_btn">${this.props.preview.base_cost}  {languagelist.budgetleft}</a>
                                               
                                            </li>
                                            
                                           {/*  <li>
                                                <img src="/assets/images/click_icon.png" />
                                                <a href="#" className="addnew_btn">{this.props.promotiondetail.total_user} {languagelist.targetuser}</a>
                                            </li> */}
                                            <li>
                                                <img src="/assets/images/click_icon.png" /> {languagelist.noview}
                                                <br/>
                                                <a href="#" className="addnew_btn">0 {languagelist.clicks}</a>
                                               
                                            </li>
                                           
                                            <li>
                                                <img src="/assets/images/reported_icon.png" /> {languagelist.reportedp}
                                                <br/>
                                                <a href="#" className="addnew_btn">0 {languagelist.reported}</a>
                                               
                                            </li>
                                            
                                            
                                            <div className="clearfix"></div>
                                        </ul>
                                       {/*  <h5>{languagelist.peoplereach}</h5>
                                        
                                        <div className="row">
                                            <div className="col-lg-12">{languagelist.approxreach} {this.props.preview.perday_reach} {languagelist.peopleperday} {languagelist.of} {this.props.preview.total_reach}</div>
                                        </div>
                                        <div className="progress">
                                            <div className="progress-bar" role="progressbar" aria-valuenow={this.props.preview.slider_percentage} aria-valuemin="0" aria-valuemax="100" style={{width:`${this.props.preview.slider_percentage}%`}}>
                                                
                                            </div>
                                        </div>
                                        <div className="clr10"></div>
                                        <div className="row">
                                           {(this.state.budget_type != 'Free') ?
                                            <div className="col-lg-6"> 
                                                <select className="form-control" name="payment_mode" value={this.props.preview.payment_mode} readOnly>   
                                                <option value='' >{languagelist.paymentmode} </option>
                                                <option value='Cash' >{languagelist.cash} </option>
                                                <option value='Online' >{languagelist.online} </option>
                                                </select>
                                            </div>
                                           : null }

                                            
                                        </div>
                                        */}
                                    </div>

                                </div>
                                <div className="clr20"></div>
                            </div>
                            </div>
                        </div>
                    </div>
                    <div className="clr20" />
                    <div className="text-center promotion_btn">
                    <div className="col-lg-3" style={(this.props.preview.checked == false) ? {display:'block'} : {display:'none'}}>&nbsp;</div>
                    <div className={(this.props.preview.checked == false) ? "col-lg-9" : "col-lg-12"}>
                       <a href={void(0)} className="btn_5" onClick={this.goEdit}>{languagelist.edit} </a> &nbsp;
                       <a href={void(0)} className="btn_5" onClick={this.changeFile}>{languagelist.createpay} </a> 
                    </div>
                    </div>                        
                   
                </div>
                <WalletConnection modalOpen={this.state.modal} closeModal={this.closeModal} evcpayment={this.evcpayment}/>          
            </div>  
        );
  }
}
const mapStateToProps = state => {
  return {
    
    preview            : state.preview.promotionPreview,
    savepromotion      : state.savepromotion.paymentUrl,
    currentUserDetails : state.login,      
    calculateReach     : state.calculatereach.calculateReach,
    evc                : state.wallet.walletReply
  }
}
const mapDispatchToProps = dispatch => {
  return {
    savePreview        : bindActionCreators(savePreview, dispatch),
    savePromotion      : bindActionCreators(savePromotion, dispatch),
    fetchReach         : bindActionCreators(fetchReach, dispatch),
    evcwalletPayment   : bindActionCreators(evcwalletPayment, dispatch),
  }
}
export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(PromotionPreview));